import React, {PureComponent} from "react"

import {H1} from "@irati/ui/src//Typography/Heading"
import {FormattedMessage} from "@irati/utils/lang"
import {Subtitle} from "../StepContent/styled"
import {MaxWContent, MarginBottom} from "./styled"

class Header extends PureComponent {
  render() {
    return (
      <MarginBottom>
        <H1 tiny>
          <FormattedMessage id="setup_tenant.inviteAdmin.title" />
        </H1>
        <MaxWContent maxWidth="400px">
          <Subtitle>
            <FormattedMessage id="setup_tenant.inviteAdmin.subtitle" />
          </Subtitle>
        </MaxWContent>
      </MarginBottom>
    )
  }
}

export default Header
